import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { apiFetch } from '../utils/api'

const VerifyResult = () => {
  const { token } = useParams()
  const [status, setStatus] = useState('loading') // loading, success, error
  const [message, setMessage] = useState('')

  useEffect(() => {
    const abortController = new AbortController()

    const verify = async () => {
      try {
        const res = await apiFetch(`/api/verify/${token}`, {
          signal: abortController.signal
        })
        const data = await res.json()
        if (res.ok) {
          setStatus('success')
          setMessage(data.message || 'Account verified successfully!')
        } else {
          setStatus('error')
          setMessage(data.error || 'Verification failed.')
        }
      } catch (error) {
        // Ignore abort errors (caused by cleanup)
        if (error.name === 'AbortError') {
          return
        }
        setStatus('error')
        setMessage('An error occurred during verification.')
      }
    }
    void verify()

    // Cleanup function to abort the request if component unmounts
    return () => {
      abortController.abort()
    }
  }, [token])

  return (
    <div className="verify-outer-container">
      <div className="login-container verify-card">
        <div className="logo">
          <h1>CodeNexus</h1>
          <p>Account Verification</p>
        </div>
        <div className="verify-content">
          {status === 'loading' && <p>Verifying your account...</p>}
          {status === 'success' && <>
            <h2 style={{ color: '#10b981', marginBottom: '12px' }}>Success!</h2>
            <p className="success-message">{message}<br /><br />Now you can login with your email and password in your application.<br /><br />You can now close this page.</p>
          </>}
          {status === 'error' && <>
            <h2 style={{ color: '#ef4444', marginBottom: '12px' }}>Error</h2>
            <p className="error-message">{message}</p>
          </>}
        </div>
      </div>
    </div>
  )
}

export default VerifyResult 